module.exports = __webpack_public_path__ + "static/media/quiz_12d.2d828c1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/quiz_12d.jpg
// module id = 692
// module chunks = 0